import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Image } from 'cloudinary-react';

import Modal from 'common/modal';
import Button from 'common/button';
import NumberInput from 'common/number-input';
import ContributeContext from '../../context';

const TipDescription = ({ show, showEntry, onAmountChange, onClose }) => {
    const { tip, subtotal } = useContext(ContributeContext);
    const amount = tip ?? 0;

    let title = 'Your tip = free fundraising';
    if (showEntry) title = amount ? 'Please enter your tip' : 'You selected "No Tip"';

    let buttonLabel = 'Close';
    if (showEntry) buttonLabel = amount ? 'Continue' : 'Continue without tipping';

    const percentage = Math.round((tip / subtotal) * 100);

    return (
        <Modal close={onClose} isOpen={show}>
            <Image
                publicId="contribution-screen-tip-hero_j2oykw"
                className="w-full block rounded-t"
                fetchFormat="auto"
                gravity="faces:auto"
                crop="fill"
                quality="auto"
                aspectRatio="2"
            />
            <div className="p-10 md:p-14 text-center">
                <h1 className="font-display uppercase text-32 text-gray-80 leading-tight tracking-wide">
                    {title}
                </h1>
                <div className="text-14 text-gray-50 leading-relaxed">
                    <p className="mt-4">
                        Your tip ensures that all money raised on Pledge It goes directly to the
                        cause. Unlike other platforms, Pledge It does not charge a platform fee
                        based on the funds raised. We rely on ‘tips’ from generous donors like you
                        to continue offering our platform for free. Thank you for empowering our
                        community!
                    </p>
                </div>
                {showEntry && (
                    <div className="mt-8">
                        <h2 className="text-18 font-black text-gray-80">Your Tip: {percentage}%</h2>
                        <div className="flex items-center justify-center mt-4">
                            <span className="flex-no-shrink text-18 pr-4 text-gray-40">$</span>
                            <NumberInput
                                value={amount / 100}
                                name="custom-amount"
                                inputMode="decimal"
                                className="input-default w-48"
                                onValueChange={x => onAmountChange(x * 100)}
                            />
                        </div>
                    </div>
                )}
                <div className="-mb-4 mt-12">
                    <Button
                        color={showEntry ? 'green' : 'gray'}
                        size="md"
                        className="text-16 font-medium block w-full"
                        onClick={onClose}
                    >
                        {buttonLabel}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

TipDescription.propTypes = {
    show: PropTypes.bool.isRequired,
    showEntry: PropTypes.bool.isRequired,
    onAmountChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default TipDescription;
